import {useRef,useState,useEffect,useContext} from 'react';
import styled from 'styled-components';
import {useHistory} from 'react-router-dom';
import {ConfigContext} from '../Context/ConfigContext';
import Container from './Common/Container';
import { FiVideo,FiVideoOff,FiMic,FiMicOff,FiUsers,FiCopy } from "react-icons/fi";

const SetupWrapper = styled.div`
    padding: 0 ${(props) => props.theme.padding.unMatch};
    height: calc(100vh - 61px);
    display: flex;
    align-items: center;
    justify-content: center;
`;

const SetupLeft = styled.div``;

const SetupRight = styled.div`
    margin-left: 15px;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
`;

const VideoContainer = styled.div`
    height: 300px
`;

const VideoItem = styled.video`
    height: 300px;
    width: 400px;
    border-radius: 5px;
`;

const VideoPlaceholder = styled.div`
    height: 300px;
    width: 400px;
    background: #4D4D4D;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const VideoPleaceHolderContent = styled.h4`
    color: #fff;
    font-size: 25px;
    font-weight: ${(props) => props.theme.font.weight.default}
`;

const SetupController = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
`;

const ControllerButton = styled.button`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: ${(props) => !props.active ? props.theme.colors.default : "none"};
    border:  ${(props) => props.active ? "2px solid "+props.theme.colors.default : "none"};
    color: ${(props) => props.active ? props.theme.colors.default : "#fff"};
    font-weight: ${(props) => props.theme.font.weight.bold};
    outline: none;
    cursor: pointer;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    & > svg  {
        width: 35px;
    }
`;

const MeetingLink = styled.h3`
    font-size: 22px;
    color: ${(props) => props.theme.colors.offWhite};
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    & > span {
        margin-right: 15px;
    }
`;

const JoinButton = styled.button`
    background: ${(props) => props.theme.backgroundColors.default};
    border: none;
    outline: none;
    height: 48px;
    width: 110px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    color: #fff;
    font-size: 15px;
    font-weight: ${(props) => props.theme.font.weight.default};
    cursor: pointer;
    border-radius: 5px;
    margin-right: 10px;
`;

const SetUpLabel = styled.h3`
    margin: 0;
`;

const Setup = ({roomId}) => {
    const {state,setter} = useContext(ConfigContext);
    const {isAudio,isVideo} = state;
    const {setIsAudio,setIsVideo} = setter;
    const history = useHistory();
    const VideoRef = useRef();

    function copyToClipboard(text) {
        const elem = document.createElement('textarea');
        elem.value = text;
        document.body.appendChild(elem);
        elem.select();
        document.execCommand('copy');
        document.body.removeChild(elem);
        alert("Copied to clipboard!")
    }

    useEffect(() => {
        navigator.mediaDevices.getUserMedia({video: isVideo,audio: isAudio})
        .then(stream => {
            VideoRef.current.srcObject = stream;
        })
        .catch(err => console.log(err));
        console.log("Config Context",state,setter);
    },[isVideo,isAudio])

    return(
        <Container>
            <SetupWrapper>
                <SetupLeft>
                    {isVideo && 
                        <VideoContainer>
                            <VideoItem ref={VideoRef} autoPlay></VideoItem>
                        </VideoContainer>
                    }
                    {!isVideo && 
                        <VideoPlaceholder ref={VideoRef}>
                            <VideoPleaceHolderContent>Camera is off</VideoPleaceHolderContent>
                        </VideoPlaceholder>
                    }
                    <SetupController>
                        <ControllerButton 
                            onClick={e => setIsAudio(!isAudio)}
                            active={isAudio}
                        >
                            {!isAudio ? <FiMicOff/> : <FiMic/> }
                        </ControllerButton>
                        <ControllerButton 
                            onClick={e => setIsVideo(!isVideo)}
                            active={isVideo}
                        >
                            {!isVideo ? <FiVideoOff/> : <FiVideo/> }
                        </ControllerButton>
                    </SetupController>
                </SetupLeft>
                <SetupRight>
                    <SetUpLabel>আপনার হার্ডওয়্যার সেটআপ করুন</SetUpLabel>
                    <MeetingLink><span>www.huddle.com/room/{roomId}</span> <FiCopy onClick={() => copyToClipboard('www.huddle.com/room/'+roomId)}/></MeetingLink>
                    <JoinButton
                        onClick={e => history.push(`/room/${roomId}`)}
                    >
                        <FiUsers/>শুরু করুন
                    </JoinButton>
                </SetupRight>
            </SetupWrapper>
        </Container>
    )
}

export default Setup;